// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class UnsubscribeRequestModel {
    static getAttributeTypeMap() {
        return UnsubscribeRequestModel.attributeTypeMap;
    }
}
UnsubscribeRequestModel.discriminator = undefined;
UnsubscribeRequestModel.attributeTypeMap = [
    {
        "name": "accountId",
        "baseName": "accountId",
        "type": "number"
    },
    {
        "name": "email",
        "baseName": "email",
        "type": "string"
    },
    {
        "name": "userId",
        "baseName": "userId",
        "type": "number"
    },
    {
        "name": "username",
        "baseName": "username",
        "type": "string"
    }
];
//# sourceMappingURL=unsubscribeRequestModel.js.map